export const getCookieValue = (key: string): string | null => {
  const encodedKey = encodeURIComponent(key);
  const cookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${encodedKey}=`));

  if (!cookie) return null;

  return decodeURIComponent(cookie.slice(cookie.indexOf('=') + 1));
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${encodeURIComponent(
    name,
  )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};
